import SingleSuperAdminUser from './SingleSuperAdminUser';

export default SingleSuperAdminUser;
